(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wbs-header-behavior"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wbs-header-shell')) {
  customElements.define('wbs-header-shell', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.wrapper = this.querySelector('.wbs-header-wrapper');
      if (!this.wrapper) return;
      this.update = () => {
        const passed = this.getBoundingClientRect().top <= 0;
        const distance = Math.max(0, -this.getBoundingClientRect().top);
        const fixed = this.dataset.sticky === 'true' && passed;
        this.classList.toggle('is-fixed', fixed);
        this.classList.toggle('is-solid', distance > Number(this.dataset.threshold || 40));
        this.style.height = this.dataset.overlay === 'true' ? '0px' : fixed ? this.wrapper.offsetHeight + 'px' : '';
      };
      addEventListener('scroll', this.update, {passive:true, signal});
      addEventListener('resize', this.update, {passive:true, signal});
      addEventListener('pageshow', this.update, {signal});
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.wrapper);
      this.update();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  });
}
if (!customElements.get('wbs-navigation')) {
  customElements.define('wbs-navigation', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.setAttribute('data-enhanced', '');
      const disclosures = [...this.querySelectorAll('details')];
      const closeOthers = current => {
        const scope = this.classList.contains('wbs-navigation--mobile') ? this : this.closest('wbs-header-shell') || this;
        scope.querySelectorAll('.wbs-nav-disclosure').forEach(d => { if (d !== current) d.open = false; });
      };
      disclosures.forEach(d => {
        d.addEventListener('toggle', () => { if (d.open) closeOthers(d); }, {signal});
        const item = d.closest('.wbs-nav-item');
        let closeTimer;
        item.addEventListener('pointerenter', e => {
          clearTimeout(closeTimer);
          if (e.pointerType === 'mouse' && this.dataset.open === 'hover' && !this.classList.contains('wbs-navigation--mobile')) { closeOthers(d); d.open = true; }
        }, {signal});
        item.addEventListener('pointerleave', () => {
          if (this.dataset.open === 'hover' && !this.classList.contains('wbs-navigation--mobile') && !item.contains(document.activeElement)) closeTimer = setTimeout(() => { if (this.isConnected) d.open = false; }, 180);
        }, {signal});
     
      });
      this.addEventListener('keydown', e => {
        if (e.key !== 'Escape') return;
        const d = e.target.closest('details[open]');
        if (d) { e.preventDefault(); e.stopPropagation(); d.open = false; d.querySelector('summary').focus(); }
      }, {signal});
      document.addEventListener('pointerdown', e => { if (!this.contains(e.target)) closeOthers(null); }, {signal});
      document.addEventListener('shopify:block:select', e => {
        if (this.getClientRects().length === 0) return;
        const d = disclosures.find(d => d.dataset.blockId === e.detail.blockId);
        if (d) { closeOthers(d); d.open = true; }
      }, {signal});
      document.addEventListener('shopify:block:deselect', () => closeOthers(null), {signal});
      addEventListener('resize', () => { closeOthers(null); }, {signal});
     
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
